import axios from '../utils/axios/index.js'

//获取验证码图片
export const captcha = (params) => {
    return axios.post('api/auth/captcha',params)
}
//登录
export const axiosLogin = (data) => {
    return axios.post('api/auth/login2',data)
}
//注册
export const axiosRegist = (data) => {
    return axios.post('api/auth/register2',data)
}
//获取信息
export const me = () => {
    return axios.post('/api/auth/me')
}

// member_id  - Member’s ID
export const getProfilePhoto = (params) => {
    return axios.post('api/profilepictures/user', {member_id: params})
}

// member_id  - Member’s ID
// profile_id - Profile’s ID
export const setProfilePhoto = (params) => {
  return axios.post('api/profilepictures/set', params)
}

export const getProfilePhotoList = () => {
  return axios.get('api/profilepictures')
}


// 获取语言
export const lang = (params) => {
    axios.defaults.params = {}
    axios.defaults.data = {}
    return axios.get('/api/language/getList',{params})
}
export const languageApi = (params) => {
    return axios.get('api/language/getList',{params})
}
export const languageApi2 = (params) => {
    return axios.get('api/dynamicwebs/getdata',{params})
}
//获取活动
export const axiosActivt = () => {
    return axios.get('/api/activities')
}
//获取活动
export const axiosActivtView = (number) => {
    axios.defaults.params = {}
    axios.defaults.data = {}
    let lang = JSON.parse(localStorage.getItem('language')).value
    return axios.get(`/api/activity/${number}&lang=${lang}`)
}
//获取直播类型/游戏类型
export const axiosGetGameType = (params)=>{
    return axios.get('/api/games/apisv2',{params})
}
//获取直播/游戏下的具体信息
export const axiosGetGameInfo = (params) => {
    return axios.get('/api/games/listsv2',{params})
}
//获取直播地址
export const axiosVideoUrl = (data) => {
    return axios.post('/api/bridge/loginBridge',data)
}
//获取公告
export const axiosGetGG = () => {
    return axios.get('/api/system/notices')
}
// 获取首页轮播图
export const axiosGetImg = (params)=>{
    return axios.get('/api/banners',{params})
}
// 获取支付方式
export const payments = (params) => {
    return axios.get("/api/payments/list",{params})
}
// 更具支付方式获取支付
export const axiosOnline = (params) => {
    return axios.get("/api/payment/online/list",{params})
}
// 支付跳转
export const recharge = (params) => {
    return axios.post("/api/recharge/online",params)
}
// 修改密码
export const modifyPassword = (params)=>{
    return axios.post("/api/member/password/modify",params)
}
// 修改支付密码
export const ChangePaymentPassword = (params)=>{
    return axios.post("/api/member/drawing_pwd/modify",params)
}
// 提现接口
export const withdrawal = (params)=>{
  return axios.post("/api/drawing",params)
}
export const withdrawal2 = (params)=>{
  return axios.post("/api/drawing",params)
}
export const saveMemberBank = (params)=>{
  return axios.post("/api/memberbanks/save",params)
}
export const displayMemberBank = ()=>{
  return axios.get("/api/memberbanks/display")
}




// 显示银行卡
export const queryBankCard = () =>{
  return axios.get(`/api/member/bank`)
}
// 添加银行卡
export const addbankcard = (params) => {
  return axios.post('/api/member/bank',params)
}
// 游戏记录
export const gamerecord = (params)=>{
  return axios.post('/api/game/record?lang=zh_cn',params)
}
// 交易记录
export const transactionRecord = (params)=>{
  return axios.post('/api/recharge/list?lang=zh_cn',params)
}



export const favoriteListApi = (params)=>{
  // name=soccer sample param
  return axios.post(`/api/games/follow?member_id=${params.member_id}&name=${params.name}`)
}

export const getPromotionListApi = (params)=>{
  // name=soccer sample param
  return axios.get(`/api/games/promotion?name=${params}`)
}

export const getPopularListApi = (params)=>{
  // name=soccer sample param
  return axios.get(`/api/games/popular?name=${params}`)
}

// Parameter : 
// 1  member_id  (Member ID)
// 2  game_id  (Game's ID)
export const setFevoriteApi = (params)=>{
  return axios.post('/api/games/follow/set', params)
}

// Parameter : 
// 1  member_id  (Member ID)
// 2  game_id  (Game's ID)
export const deleteFevoriteApi = (params)=>{
  return axios.post('/api/games/follow/delete', params)
}


// 获取游戏列表
export const gameList = ()=>{
  return axios.get('/day7/getGameCodeList')
}
// 开始游戏
export const StartGame = (params)=>{
  return axios.post('/api/day7/day7LoginV2',params)
}
// 获取游戏里的余额
export const GameBalance = (params)=>{
  return axios.get(`/api/day7/getAllBalance?currency=BRL&platType=${params.platType}`)
}

export const addFavorite = (params)=>{
  return axios.post('api/games/follow/set',params)
}
export const deleteFavorite = (params)=>{
  return axios.post('api/games/follow/set',params)
}

export const bonusHistory = (params) => {
  return axios.post('api/member/vip/history',params)
}

export const coverHistory = (params) => {
  return axios.post('api/cover/history',params)
}

export const registerSubordinate = (params) => {
  return axios.post('api/agency/subordinate/register',params)
}

export const agencyReward = (params) => {
  return axios.post('api/agency/reward',params)
}

export const agencyInviteRecord = (params) => {
  return axios.post('api/agency/inviterecord',params)
}

export const fetchAgencyMechanism = async () => {
  try {
    const [rechargeResponse, bettingResponse, settlementResponse] = await Promise.all([
      axios.get('api/agency/mechanism/recharge'),
      axios.get('api/agency/mechanism/betting'),
      axios.get('api/agency/mechanism/settlement')
    ]);

    return {
      recharge: rechargeResponse.data,
      betting: bettingResponse.data,
      settlement: settlementResponse.data
    };
  } catch (error) {
    console.error(error);
  }
};
// 体现接口
export const Withdraw = async (params) => {
  return axios.post('/api/drawing',params)
}

export const Withdrawal = async (params) => {
  try {
    const res = await axios.post('/api/drawing', params);
    alert("The withdrawal application has been submitted successfully.Please wait for the administrators review.");
    return res; // Assuming you want to return the data from the response
  } catch (error) {
    alert(error.response.data.message);
    return error
  }
}
export const fetchRebates = (params) => {
  return axios.post('/api/games/rebates/list', params)
}

export const fetchRebatesDetail = (params) => {
  return axios.post('/api/games/rebates/details', params)
}

export const fetchSocialsLink = (params) => {
  return axios.get(`/api/socialmedialinks/get?site=${params.site}`)
}



// WEBPACK FOOTER //
// ./src/api/apiIndex.js